const setAuthUser = (user) => {
	return { user: user, type: 'SET_AUTH_USER' };
};

const data = {
	setAuthUser,
};
export default data;
